import { getLocale } from 'i18n/locale';
import { ELocale } from 'i18n/localeEnum';
import weSkiResortMapping from './resort-mapping.json';
import weSkiRegionMapping from './region-mapping.json';

interface IWeSkiMapping {
  [key: string]: string;
}

const IT_LOCALE_MAPPING = ['1374', '604', '605', '2593'];

export function weSkiDestinationId({ resortId, regionId }: { resortId?: string, regionId?: string }) {
  // https://mountainnews.jira.com/browse/OWR-1948
  if (getLocale() === ELocale.IT_IT) {
    if (resortId) {
      if (IT_LOCALE_MAPPING.includes(resortId)) {
        return (weSkiResortMapping as IWeSkiMapping)[resortId];
      }
    }
    return null;
  }
  if (resortId) {
    return (weSkiResortMapping as IWeSkiMapping)[resortId];
  }

  if (regionId) {
    return (weSkiRegionMapping as IWeSkiMapping)[regionId];
  }
  return null;
}

export function hasWeSkiIntegration({ resortId, regionId }: { resortId?: string, regionId?: string }) {
  return weSkiDestinationId({ resortId, regionId });
}
